import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ArrowRightIcon } from 'lucide-react';
export function FinalCTASection() {
  return <section className="py-14 md:py-20 px-6 bg-burgundy relative overflow-hidden" data-id="element-59">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-61">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 font-serif text-cream" data-id="element-62">
            Tu historia merece un{' '}
            <span className="text-gold italic" data-id="element-63">final diferente</span>
          </h2>
          <p className="text-base md:text-xl text-cream/90 mb-10 max-w-2xl mx-auto font-serif italic leading-relaxed" data-id="element-64">
            No esperes otro año más. Hoy puedes dar el paso que cambia todo.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col items-center" data-id="element-65">
          <Button className="w-full md:w-auto text-base px-10 py-5 shadow-2xl hover:shadow-gold/20 flex items-center justify-center gap-3 mb-4 bg-gold text-burgundy border-gold hover:bg-cream hover:text-burgundy hover:border-cream" data-id="element-66">
            <span className="text-sm md:text-base font-bold" data-id="element-67">
              Quiero transformarme en una mujer de alto valor ahora
            </span>
            <ArrowRightIcon className="w-5 h-5" data-id="element-68" />
          </Button>
          <p className="text-gold font-medium tracking-wide text-sm mt-2" data-id="element-69">
            $9.95 USD — Pago único
          </p>
        </motion.div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-1/2 left-0 w-64 h-64 bg-gold/10 rounded-full filter blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-70"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-gold/10 rounded-full filter blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-71"></div>
    </section>;
}